import { useState, type PropsWithChildren } from "react";
import { OpenExcursionContext } from "../contexts";

export interface ExcursionContextProviderProps extends PropsWithChildren {}

export const ExcursionContextProvider = ({
  children,
}: ExcursionContextProviderProps) => {
  const [openExcursions, setOpenExcursions] = useState<string[]>([]);

  const addOpenExcursion = (excursionId: string) => {
    setOpenExcursions((prev) => [...prev, excursionId]);
  };

  const closeUppermostExcursion = () => {
    setOpenExcursions((prev) => prev.slice(0, -1));
  };

  return (
    <OpenExcursionContext.Provider
      value={{ openExcursions, addOpenExcursion, closeUppermostExcursion }}
    >
      {children}
    </OpenExcursionContext.Provider>
  );
};
